(function (ng) {
    //service that retrieves the random messages shown when a user adds a product to their package
    ng.module('evo.Packages.Services').factory('successMessageService', [
        function () {
            var index = 0,
                messages = [
                    'Great Choice!',
                    'Right on!',
                    'Woaahhh wicked!',
                    'Sick choice, brah!',
                    'The force is strong with this one!',
                    'This package is on point!',
                    'Bingo!',
                    'Kowabunga!',
                    'Aww.. hellz yeah!',
                    'BOOyah!',
                    'Killing It!',
                    'Yeowzah!'
                ];

            function getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            }

            return {
                getRandomMessage: function () {
                    var indexThisTime = index;

                    //assign index to a new random message
                    //and make sure that the message will be different next time
                    do {
                        index = getRandomInt(0, messages.length);
                    } while (indexThisTime === index);

                    return messages[indexThisTime];
                }
            };
        }
    ]);
})(angular);